import { generateUUID } from 'src/utils/generateUUID'

export const rotateLoginId = () => {
  window.localStorage.setItem('login_id', generateUUID())
}
